import { Row } from 'antd';
import styled, { css } from 'styled-components';

import { media } from '~src/styles/media-templates';

export const FiltersContainer = styled.div`
  padding: 30px 0;
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  > div {
    :first-child {
      justify-content: start;
    }
  }

  ${media.tablet`
    flex-wrap: wrap;
  `}
`;

const LabelFont = styled.span`
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: 600;
  color: ${({ theme }) => theme.baseBlue.a10};
  line-height: 21px;
`;

export const FilterRow = styled(Row)`
  width: 100%;
`;

export const LabelAbout = styled(LabelFont)`
  white-space: normal;
  padding-right: 10px;
`;

export const FilterContent = styled.span`
  margin-left: 40px;
`;

export const FilterBox = styled.div<{ $hideLabel?: boolean }>`
  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: nowrap;
  &:first-child {
    ${FilterContent} {
      margin-left: ${({ $hideLabel }) => ($hideLabel ? '0' : '45px')};
    }
  }

  ${media.tablet`
    margin-right: 15px;
  `}
`;

export const FilterName = styled(LabelFont)`
  opacity: 0.5;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  text-transform: uppercase;
  display: flex;
  flex-wrap: wrap;
`;

export const FilterIcon = styled.div<{ $tilt?: string }>`
  margin-right: 5px;
  opacity: 0.5;
  ${({ $tilt }) =>
    $tilt
      ? css`
          transform: rotate(${$tilt});
        `
      : ''};
`;

export const FilterBtn = styled.button`
  border: 0;
  background: transparent;
  padding: 0;
  outline: none;
  display: flex;
  align-items: center;
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'normal')};

  &:hover {
    ${FilterName},
    ${FilterIcon} {
      opacity: ${({ disabled }) => (disabled ? '.5' : '1')};
    }
  }

  &.active {
    ${FilterName},
    ${FilterIcon} {
      opacity: 1;
      cursor: default;
    }
  }
`;

export const FilterTooltip = styled.div`
  margin-left: 5px;
  height: 15px;
  line-height: normal;
`;

export const FilterAmount = styled.div<{ $itemAmount: boolean }>`
  width: 30px;
  visibility: ${(itemAmount) => (itemAmount ? 'visible' : 'hidden')};
  padding-left: 4px;
  text-align: left;
`;
